const button = document.querySelector("#myAlertButton");
button.addEventListener("click", () => {
  alert("Hello World!");
});
button.disabled = false;
